import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn, Check } from 'lucide-react';
type Role = 'host' | 'cleaner' | 'manutentore';
interface DemoAccount {
  role: Role;
  label: string;
  email: string;
  password: string;
  avatar: string;
}
const demoAccounts: DemoAccount[] = [{
  role: 'host',
  label: 'Host',
  email: 'massimo.giri@host.it',
  password: 'demo-host',
  avatar: 'https://cdn.magicpatterns.com/uploads/aDiier9xTcmPNhp9njGfUz/80.jpg'
}, {
  role: 'cleaner',
  label: 'Cleaner Manager',
  email: 'cleaner@manager.it',
  password: 'demo-cleaner',
  avatar: 'https://cdn.magicpatterns.com/uploads/5qDLCxcppx3Xbyc5uL4GS6/Screenshot_2026-03-22_alle_16.12.18.png'
}, {
  role: 'manutentore',
  label: 'Manutentore',
  email: 'tecnico@manutenzione.it',
  password: 'demo-tecnico',
  avatar: 'https://cdn.magicpatterns.com/uploads/fTors2Yrr32xiEFMswChLH/Installatore-E-Manutentore-Meccanico.webp'
}];
const roleRoutes: Record<Role, string> = {
  host: '/dashboard',
  cleaner: '/cm',
  manutentore: '/man'
};
export function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState<Role>('host');
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
  const fillAccount = (account: DemoAccount) => {
    setEmail(account.email);
    setPassword(account.password);
    setRole(account.role);
    setSelectedRole(account.role);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    localStorage.setItem('cleanai_onboarded', '1');
    navigate(roleRoutes[role]);
  };
  return <main className="min-h-screen w-full bg-background flex items-center justify-center p-4" data-id="element-2821">
      <div className="w-full max-w-sm" data-id="element-2822">
        {/* Logo */}
        <div className="text-center mb-8" data-id="element-2823">
          <h1 className="text-2xl font-bold text-navy" data-id="element-2824">
            Clean<span className="text-coral" data-id="element-2825">AI</span>
          </h1>
          <p className="text-sm text-muted-foreground mt-1" data-id="element-2826">
            Accedi al tuo account
          </p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-xl border border-border shadow-sm p-6" data-id="element-2827">
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-2828">
            <div data-id="element-2829">
              <label htmlFor="email" className="block text-xs font-medium text-navy mb-1.5" data-id="element-2830">
                Email
              </label>
              <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="nome@esempio.it" required className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none transition-all min-h-[44px]" data-id="element-2831" />
            </div>
            <div data-id="element-2832">
              <label htmlFor="password" className="block text-xs font-medium text-navy mb-1.5" data-id="element-2833">
                Password
              </label>
              <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required className="w-full px-3 py-2.5 border border-border rounded-lg text-sm focus:ring-2 focus:ring-coral focus:border-transparent outline-none transition-all min-h-[44px]" data-id="element-2834" />
            </div>
            <button type="submit" className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-coral text-white rounded-xl text-sm font-semibold hover:bg-coral-600 transition-colors min-h-[48px]" data-id="element-2835">
              <LogIn size={18} data-id="element-2836" />
              Accedi
            </button>
          </form>

          <p className="text-xs text-muted-foreground text-center mt-5 pt-5 border-t border-border" data-id="element-2837">
            Non hai un account?{' '}
            <button type="button" onClick={() => navigate('/onboarding')} className="font-medium text-coral hover:underline" data-id="element-2838">
              Registrati
            </button>
          </p>
        </div>

        {/* Quick-access shortcuts */}
        <div className="mt-6" data-id="element-2839">
          <div className="flex items-center gap-3 mb-3" data-id="element-2840">
            <div className="flex-1 h-px bg-border" data-id="element-2841" />
            <span className="text-[11px] uppercase tracking-wider font-medium text-muted-foreground" data-id="element-2842">
              Accesso rapido demo
            </span>
            <div className="flex-1 h-px bg-border" data-id="element-2843" />
          </div>
          <div className="space-y-2" data-id="element-2844">
            {demoAccounts.map(account => {
            const isSelected = selectedRole === account.role;
            return <button key={account.role} type="button" onClick={() => fillAccount(account)} aria-pressed={isSelected} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors text-left min-h-[44px] border ${isSelected ? 'border-coral bg-coral/5' : 'bg-white border-border hover:border-coral hover:bg-coral/5'}`} data-id="element-2845">
                  <img src={account.avatar} alt="" className="w-10 h-10 rounded-full object-cover object-center border border-border flex-shrink-0" data-id="element-2846" />
                  <span className="block text-sm font-medium text-navy leading-tight min-w-0 truncate flex-1" data-id="element-2847">
                    {account.label}
                  </span>
                  {isSelected && <span className="flex-shrink-0 w-5 h-5 rounded-full bg-coral flex items-center justify-center" data-id="element-2848">
                      <Check size={13} className="text-white" data-id="element-2849" />
                    </span>}
                </button>;
          })}
          </div>
        </div>
      </div>
    </main>;
}